export default __webpack_public_path__ + "static/media/keyboard_arrow_up.56326919.svg";